import { getLocaleTime } from '../../utils.js'
const fb = require('../../firebaseConfig.js')

export default {
    state: {
        costCenters: [],
		costCenter: {},
    },
    getters: {
        costCenter: (state) => {
			return state.costCenter
        },
        costCenters: (state) => {
            return state.costCenters
        }
    },
    mutations: {
        setCostCenters(state, val) {
			state.costCenters = val
		},
		setCostCenter(state, val) {
			state.costCenter = val
		},
    },
    actions: {
        async fetchCostCenters({commit}) {
            await fb.costCentersCollection.onSnapshot(querySnapshot => {
                let costCenters = [];
                querySnapshot.forEach(costCenter => {
                    let costCenterEdited = costCenter.data()
                    costCenterEdited.id = costCenter.id
                    costCenterEdited.startDate = getLocaleTime(costCenterEdited.startDate.toDate())
                    costCenterEdited.endDate = getLocaleTime(costCenterEdited.endDate.toDate())
                    costCenters.push(costCenterEdited)
                })
                commit('setCostCenters', costCenters)
            })
        },
        async fetchCostCenter({commit}, { costCenterId }) {
            await fb.costCentersCollection.doc(costCenterId).get().then(res => {
                let currentCostCenter = res.data()
                currentCostCenter.id = costCenterId
                currentCostCenter.startDate = getLocaleTime(currentCostCenter.startDate.toDate())
                currentCostCenter.endDate = getLocaleTime(currentCostCenter.endDate.toDate())
                commit('setCostCenter', currentCostCenter)
            })
        },
        createCostCenter({getters}, payload) {
            if(payload.id) {
                fb.costCentersCollection.doc(payload.id).update({
                    code: payload.code,
                    name: payload.name,
                    administrator: payload.administrator,
                    startDate: fb.fromDate(payload.startDate),
                    endDate: fb.fromDate(payload.endDate),
                    updatedOn: fb.fromDate(new Date()),
                    updatedBy: getters.userId
                })
                return
            }

            fb.costCentersCollection.add({
                code: payload.code,
                name: payload.name,
                administrator: payload.administrator,
                startDate: fb.fromDate(payload.startDate),
                endDate: fb.fromDate(payload.endDate),
                createdOn: fb.fromDate(new Date()),
                createdBy: getters.userId,
            })
        },
    }
}